import { Modal } from './Modal';
import { ButtonPrimary } from './ButtonPrimary';

interface ChangelogModalProps {
  open: boolean;
  onClose: () => void;
  version: string;
  verifiedAt: string;
}

export function ChangelogModal({ open, onClose, version, verifiedAt }: ChangelogModalProps) {
  return (
    <Modal open={open} title={`Constants ${version}`} onClose={onClose}>
      <div class="space-y-4 text-sm text-body">
        <dl class="space-y-2">
          <div class="flex justify-between">
            <dt class="text-body/70">2026 annual limit</dt>
            <dd class="font-semibold">$7,000</dd>
          </div>
          <div class="flex justify-between">
            <dt class="text-body/70">Cumulative max (since 2009)</dt>
            <dd class="font-semibold">$109,000</dd>
          </div>
          <div class="flex justify-between">
            <dt class="text-body/70">2025 withdrawals restore</dt>
            <dd class="font-semibold">Jan 1, 2026</dd>
          </div>
        </dl>
        <p class="text-xs text-body/70">
          Constants verified against canada.ca on {verifiedAt}.{' '}
          <a
            href="https://www.canada.ca/en/revenue-agency/services/tax/individuals/topics/tax-free-savings-account/contributions.html"
            target="_blank"
            rel="noopener noreferrer"
            class="underline focus:outline-none focus:ring-2 focus:ring-hudson-navy rounded"
          >
            CRA source →
          </a>
        </p>
        <ButtonPrimary onClick={onClose}>Got it</ButtonPrimary>
      </div>
    </Modal>
  );
}
